import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import MainMenu from "@/pages/MainMenu";
import PlayPage from "@/pages/PlayPage";
import Play3DPage from "@/pages/Play3DPage";
import Leaderboard from "@/pages/Leaderboard";
import Champions from "@/pages/Champions";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminRevenue from "@/pages/AdminRevenue";
import ReferralLanding from "@/pages/ReferralLanding";
import ReferralDashboard from "@/pages/ReferralDashboard";
import ReferralPublic from "@/pages/ReferralPublic";
import TradeHighlights from "@/pages/TradeHighlights";
import { LanguageProvider } from "@/i18n";
import { primeSeenSkins } from "@/lib/skins";

function App() {
  useEffect(() => {
    // Prime the "seen skins" cache once so previously-unlocked skins
    // don't fire the unlock trailer on next game-over.
    primeSeenSkins();
  }, []);
  return (
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainMenu />} />
          <Route path="/play/:level" element={<PlayPage />} />
          <Route path="/play3d/:level" element={<Play3DPage />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/champions" element={<Champions />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/revenue" element={<AdminRevenue />} />
          <Route path="/r/:code" element={<ReferralLanding />} />
          <Route path="/referrals" element={<ReferralPublic />} />
          <Route path="/referrals/dashboard" element={<ReferralDashboard />} />
          <Route path="/trade-highlights" element={<TradeHighlights />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(0,0,0,0.85)",
            border: "1px solid rgba(0,240,255,0.4)",
            color: "#f8f9fa",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            letterSpacing: "0.1em",
          },
        }}
      />
    </div>
    </LanguageProvider>
  );
}

export default App;
